export const PROJECT_TYPES = [
  "New construction",
  "Renovation",
  "Replacement / repair",
  "Accessories only",
  "Multi-location program",
  "Other commercial project",
] as const;

export const MATERIAL_PREFERENCES = [
  "Not sure — help me compare",
  "Powder Coated Steel",
  "Plastic Laminate",
  "Solid Plastic (HDPE)",
  "Stainless Steel",
  "Phenolic",
  "Accessories only",
] as const;

export type ProjectType = (typeof PROJECT_TYPES)[number];
export type MaterialPreference = (typeof MATERIAL_PREFERENCES)[number];
